import { Injectable } from '@angular/core';
import { ClaimApiService } from '../api/claim-api.service';
import * as ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {

  constructor(
    private claimApiService: ClaimApiService
  ) { }

  async getClaim(shopId: string, filters: any) {
    return this.claimApiService.getClaim(shopId, filters).then((response: any) => {
      console.log(response)
      if (response.success) {
        return { success: true, data: response.data, count: response.count }
      } else {
        return { success: false, message: response.message }
      }
    })
  }

  async checkProductWarraty(barcode: string) {
    return this.claimApiService.checkProductWarraty(barcode).then((response: any) => {
      console.log(response)
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.error ? response.error.message : response.message }
      }
    })
  }

  async createClaimProduct(body: any) {
    return this.claimApiService.createClaimProduct(body).then((response: any) => {
      console.log(response)
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.error ? response.error.message : response.message }
      }
    })
  }

  getShopByShopId(shopId: string) {
    return this.claimApiService.getShopByShopId(shopId).then((response: any) => {
      console.log(response)
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.error ? response.error.message : response.message }
      }
    })
  }

  validateClaimSerial(serialNo: string) {
    return this.claimApiService.validateClaimSerial(serialNo).then((response: any) => {
      console.log(response)
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.error ? response.error.message : response.message }
      }
    })
  }

  async generateClaimReport(data: any[], fileName: string) {
    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet('รายการเคลม');
    worksheet.columns = [
      { header: 'หมายเลขเคลม', key: 'claim_ref', width: 20 },
      { header: 'วันที่เคลม', key: 'claim_date', width: 20 },
      { header: 'บาร์โค้ดส่งเคลม', key: 'claim_serial', width: 20 },
      { header: 'ชื่อสินค้า', key: 'product_name', width: 30 },
      { header: 'ผู้เคลม ', key: 'user_claim', width: 20 },
      { header: 'อาการชำรุด', key: 'description', width: 20 },
      { header: 'เคลมให้กับ', key: 'claim_type', width: 10 },
      { header: 'เบอร์โทรศัพท์', key: 'phone', width: 20 },
      { header: 'สถานะการเคลม', key: 'claim_status', width: 20 },
      { header: 'สถานะการดำเนินการ', key: 'status', width: 20 },
      { header: 'วิธีการเคลม', key: 'process_detial', width: 20 },
      { header: 'บาร์โค้ดส่งกลับ', key: 'return_serial', width: 20 },
      { header: 'สินค้าที่ส่งกลับ', key: 'return_product_name', width: 30 },
    ];

    data.forEach((row) => {
      worksheet.addRow(row);
    });

    worksheet.getRow(1).font = { bold: true, color: { argb: '000' } };

    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    this.saveExcelFile(buffer, `${fileName}.xlsx`);
  }

  private saveExcelFile(buffer: ArrayBuffer, filename: string) {
    const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(data, filename);
  }
}
